<template>
  <div class="container">
    <div class="terms-container">
      <tabs type="primary" :itemStyle="myTheme.customizeButton"
      v-model="activeTab"
      >
        <tab-pane label="policy">
          <template slot="label">{{ $t('label.privacy_policy') }}</template>
          <div v-html="docs.privacy_policy"></div>
        </tab-pane>
        <tab-pane label="terms">
          <template slot="label">{{ $t('label.terms_and_conditions') }}</template>
          <div v-html="docs.terms_and_conditions"></div>
        </tab-pane>
        <tab-pane label="allergy">
          <template slot="label">{{ $t('label.allergy_information') }}</template>
          <div v-html="docs.allergy_information"></div>
        </tab-pane>
      </tabs>
      <n-button v-if="!hideBackButton"
        id="back"
        class="btn btn-primary btn-lg btn-round"
        v-bind:style="myTheme.customizeButton"
        @click="goBack()"
      > {{ $t('button.go_back') }} </n-button>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { Tabs, TabPane , Button} from "@/components";

export default {
  name: "terms-and-conditions",
  components: {
    [Button.name]: Button,
    Tabs,
    TabPane
  },
  props:{
    hideBackButton : Boolean
  },
  data() {
    return {
      activeTab:"policy"
    };
  },
  computed: {
    ...mapState({
      docs: state => state.docs
    }),
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },
  },
  watch: {
    "$route.params.doc"(value) {
      this.activeTab = value;
    }
  }
};
</script>
